import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { getLiveReportSales } from "../../client/user/live-report";
import { LiveReportSales } from "../../models/live-report";

/**
 * Live sales for a single event in a live report.
 *
 * Polls every 30s when the tab is visible and `enabled` is true. Stops in the background.
 */
export function useLiveReportSales(
  eventId: number | null | undefined,
  options: { enabled?: boolean } = {}
): UseQueryResult<LiveReportSales, Error> {
  const enabled = (options.enabled ?? true) && typeof eventId === "number";
  return useQuery({
    queryKey: ["live-report", "viewer", "sales", eventId],
    queryFn: () => getLiveReportSales(eventId as number),
    enabled,
    staleTime: 15_000,
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
  });
}
